module.exports = __webpack_public_path__ + "media/images/icons/filled/security-scan-7641babf55585c9ffb7e809c24724b36.svg";